import axios from 'axios'
import { ErrorWrapper, ResponseWrapper } from './utils'
import { API_URL } from '../env'
import { Http } from '@/services/http.init'
import { getLoginFingerprint } from '../utils/fingerprint'

var Vue = require('vue')

let BEARER = ''

export class AuthService {
  /**
   ******************************
   * @API
   ******************************
   */

  static request (status = { auth: true }) {
    return new Http(status)
  }

  static async makeLogin ({ username, password }) {
    const fingerprint = await getLoginFingerprint()

    return new Promise((resolve, reject) => {
      axios.post(`${API_URL}/auth/login/`, { username, password, fingerprint })
        .then(response => {
          _setAuthData(response.data.auth_token, response.data.username, response.data.is_team_admin)
          return resolve(new ResponseWrapper(response, response.data, ''))
        }).catch(error => reject(new ErrorWrapper(error)))
    })
  }

  static async makeRegister (_userData) {
    return new Promise((resolve, reject) => {
      axios.post(`${API_URL}/auth/users/`, _userData)
        .then(response => {
          return resolve(new ResponseWrapper(response, response.data, ''))
        }).catch(error => reject(new ErrorWrapper(error)))
    })
  }

  // static async makeRegister (_userData) {
  //   return new Promise((resolve, reject) => {
  //     axios.post(`${API_URL}/auth/users/`, _userData)
  //       .then(response => {
  //         return resolve(new ResponseWrapper(response, response.data, ''))
  //       }).catch(error => reject(new ErrorWrapper(error)))
  //   })
  // }

  static makeLogout () {
    _resetAuthData()
  }

  static async sendPasswordResetEmail (_userData) {
    return new Promise((resolve, reject) => {
      axios.post(`${API_URL}/auth/password-reset-email/`, _userData)
        .then(response => {
          return resolve(new ResponseWrapper(response, response.data, ''))
        }).catch(error => reject(new ErrorWrapper(error)))
    })
  }

  static async passwordResetConfirm (_userData) {
    return new Promise((resolve, reject) => {
      axios.post(`${API_URL}/auth/password-reset-confirm/`, _userData)
        .then(response => {
          return resolve(new ResponseWrapper(response, response.data, ''))
        }).catch(error => reject(new ErrorWrapper(error)))
    })
  }

  /**
   ******************************
   * @METHODS
   ******************************
   */

  static getAuthToken () {
    return Vue.default.cookie.get('token')
  }

  /** Non-empty token only — avoids sending `Authorization: Token undefined` (Django 401). */
  static getValidAuthToken () {
    const token = AuthService.getAuthToken()
    if (!token) return null
    const trimmed = String(token).trim()
    if (!trimmed || trimmed === 'undefined' || trimmed === 'null') return null
    return trimmed
  }

  static axiosAuthConfig () {
    const token = AuthService.getValidAuthToken()
    if (!token) return undefined
    return {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + token
      }
    }
  }

  static clearAuthToken () {
    Vue.default.cookie.set('token', '', { expires: 0 })
  }

  static setTeamAdmin (isTeamAdmin) {
    Vue.default.cookie.set('is_team_admin', isTeamAdmin, { expires: 999 })
  }

  static setAuthToken (refreshToken) {
    Vue.default.cookie.set('token', refreshToken, { expires: 999 })
  }

  static getBearer () {
    return BEARER
  }

  static setBearer (accessToken) {
    BEARER = `Bearer ${accessToken}`
  }

  static resetPasswordAndSendMail (data) {
    // data = {'userId':61}
    const url = `${API_URL}/auth/reset-password-and-send-mail/`
    const headersConfig = this.request().request
    return new Promise((resolve, reject) => {
      axios.put(url, data, headersConfig)
        .then(response => {
          return resolve(new ResponseWrapper(response, response.data, ''))
        }).catch(error => reject(new ErrorWrapper(error)))
    })
  }
}

/**
 ******************************
 * @private_methods
 ******************************
 */

function _resetAuthData () {
  AuthService.clearAuthToken()
  Vue.default.cookie.set('username', '')
}

function _setAuthData (token, username, isTeamAdmin) {
  AuthService.setAuthToken(token)
  Vue.default.cookie.set('username', username, { expires: 999 })
  Vue.default.cookie.set('is_team_admin', isTeamAdmin, { expires: 999 })
}
